/**
 * A watch rule's severity (PRD-0075 R-B1): set on the rule, shown on each alert it raises.
 */
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { RuleSeverity } from '@/services/api/case-monitor'

export const RULE_SEVERITIES: readonly RuleSeverity[] = ['high', 'medium', 'low']

const VARIANTS = { high: 'destructive', medium: 'warning', low: 'muted' } as const

export function SeverityBadge({ severity }: { severity: RuleSeverity }) {
  const { t } = useTranslation()
  return <Badge variant={VARIANTS[severity]}>{t(`cases.monitor.severity.${severity}`)}</Badge>
}
